import { useNavigate } from 'react-router'

import { useErrorHandler } from '../../hooks/useErrorHandler'
import { RecordFactory } from '../../models/RecordFactory'
import { User } from '../../models/User'
import { useOnboardingContext } from '../../providers/OnboardingProvider'
import { SetupCancellationPage } from '../settings/SetupCancellationPage'

export function SetupOnboardingPaymentsPage() {
    const { advanceOnboardingState } = useOnboardingContext()
    const { logAndDisplayError } = useErrorHandler()
    const navigate = useNavigate()

    const onNextHandler = async (user: User) => {
        const userResult = await RecordFactory.getInstance().sendUser(user, undefined)
        if (!userResult.ok) {
            logAndDisplayError(userResult.error)
            return
        }
        await advanceOnboardingState()
    }

    return (
        <SetupCancellationPage forOnboarding onSave={onNextHandler} onClose={() => navigate('/')} />
    )
}
